import { createSelector } from 'reselect';

const getAssets = state => state.assets;
const getAssetId = state => state.modal.assetID;

export const getAssetForId = id => {
    return createSelector(getAssets, assets => assets[id]);
};

export const getSelectedAsset = createSelector(
    [getAssets, getAssetId],
    (assets, id) => assets[id] || {}
);



// WEBPACK FOOTER //
// ./src/selectors/assets.js